// This dialog shows the payment deposits in a grid format so that it is easy
// to copy and paste the deposits into the budget tracking sheet.
import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";

function PaymentInfoByDateGridBox({ open, onClose, weeklySummary, weekKey }) {
  const handleClose = () => {
    onClose(false);
  };

  // This is the year the order was placed YYYY
  const year = weekKey.substring(0, 4);
  // This is the month the order was placed MM
  const month = weekKey.substring(4, 6);
  // This is the day the order was placed DD
  const day = weekKey.substring(6, 8);
  // The date of transaction we are looking at.
  const depositDate = year + "-" + month + "-" + day;
  // This will contain the weeklySummary with each week showing the deposits and refunds. {[weekday : {Etransfer, Refund, etc.}]}
  const weekStats = weeklySummary[weekKey];

  return (
    <Dialog
      fullWidth={true}
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">
        Deposit Info for {depositDate}{" "}
      </DialogTitle>
      <DialogContent>
        <table id="tableId" border="1">
          <thead>
            <tr>
              <th>Deposit Info</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ backgroundColor: "orange" }}>
              <td>{parseFloat(weekStats.ETransfer).toFixed(2)}</td>
            </tr>
            <tr style={{ backgroundColor: "orange" }}>
              <td>{parseFloat(weekStats.Cash).toFixed(2)}</td>
            </tr>
            <tr style={{ backgroundColor: "orange" }}>
              <td>{parseFloat(weekStats.F2PMCredits).toFixed(2)}</td>
            </tr>
            <tr style={{ backgroundColor: "orange" }}>
              <td>{parseFloat(weekStats.Refunds).toFixed(2)}</td>
            </tr>
            <tr style={{ backgroundColor: "orange" }}>
              <td>{parseFloat(weekStats.Mileage).toFixed(2)}</td>
            </tr>
            <tr style={{ backgroundColor: "orange" }}>
              <td>{parseFloat(weekStats.Packaging).toFixed(2)}</td>
            </tr>
            <tr style={{ backgroundColor: "orange" }}>
              <td>{parseFloat(weekStats.CreditCard).toFixed(2)}</td>
            </tr>
            <tr style={{ backgroundColor: "orange" }}>
              <td>{parseFloat(weekStats.Misc).toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

PaymentInfoByDateGridBox.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  weeklySummary: PropTypes.object.isRequired,
  weekKey: PropTypes.string.isRequired,
};

export default function PaymentInfoByDateGridDialog({
  weeklySummary,
  weekKey,
}) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <div>
        <div>
          <Button color="primary" onClick={handleClickOpen}>
            GRID
          </Button>
        </div>
      </div>
      <PaymentInfoByDateGridBox
        open={open}
        onClose={handleClose}
        weeklySummary={weeklySummary}
        weekKey={weekKey}
      />
    </div>
  );
}
